import React from 'react'
import standardResearchImg from '../../../../images/puzzles/standardResearch.png'

function TheChainedCupboard() {    
    return (
        <div className="puzzleContainer">
            <img className="puzzlePopUp_img" src={standardResearchImg} alt="the bookcase from the office" height='50%'/> 
            <p className="puzzlePopUp_text" style={{marginBottom: '2em'}}>
                Pouring the chemical mixture on the chain causes it to fizz and pop as the metal slowly disintegrates. Finally the cupboard door creaks open. Inside is some of the Professor's research.
            </p>  
        </div>
    )
}

export default TheChainedCupboard